
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Checkbox, FormItem, Input, Option, Select } from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';

// option
import packagingOptions from '@/constants/packagingOptions';

// types
import {
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    NullableNumberInput,
    'el-checkbox': Checkbox,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class DeliveryInformation extends Vue {
  @Prop({ type: Object }) value!: ShipmentDocumentDataInput;
  @Prop({ type: Object }) document!: ShipmentDocumentFields;

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;
  readonly packagingOptions = packagingOptions();

  // For "dangerous" display condition
  get isLandTransportation() {
    if (this.document.documentType === 'land_transportation_export') {
      return true;
    } else if (this.document.documentType === 'land_transportation_import') {
      return true;
    } else {
      return false;
    }
  }

  get descriptionOfGoods() {
    return this.value.descriptionOfGoods;
  }

  set descriptionOfGoods(data) {
    this.$emit('input', { ...this.value, descriptionOfGoods: data });
  }

  get packagingQuantity() {
    return this.value.packagingQuantity;
  }

  set packagingQuantity(data) {
    this.$emit('input', { ...this.value, packagingQuantity: data });
  }

  get packaging() {
    return this.value.packaging;
  }

  set packaging(data) {
    this.$emit('input', { ...this.value, packaging: data });
  }

  get grossWeight() {
    return this.value.grossWeight;
  }

  set grossWeight(data) {
    this.$emit('input', { ...this.value, grossWeight: data });
  }

  get grossVolume() {
    return this.value.grossVolume;
  }

  set grossVolume(data) {
    this.$emit('input', { ...this.value, grossVolume: data });
  }

  get dangerous() {
    return this.value.dangerous;
  }

  set dangerous(data) {
    this.$emit('input', { ...this.value, dangerous: data });
  }
}
